/* eslint-disable @typescript-eslint/default-param-last */
import { createSlice } from '@reduxjs/toolkit';
import REDUX_SLICE_NAMES from 'consts/redux-slice-names';
import DEFAULT_CONST from 'consts/default';
import { useAppDispatch, useAppSelector } from '../hooks';
import { RootState } from '../store';
import { ICustomTableAction, CustomTableReducerType } from '../reducer-types';

const initialState: CustomTableReducerType = {
  pageIndex: DEFAULT_CONST.PAGE_INDEX,
  pageSize: DEFAULT_CONST.PAGE_SIZE,
  sortDirection: 'desc',
  sortField: undefined,
  searchFields: undefined,
  generalSearchField: undefined,
  filterFields: undefined,
  adminTableType: 'category',
  subCategory: undefined,
  subCategoryUrl: undefined,
  navigateShowAll: false,
  subId: undefined,
  subUrl: undefined,
  checkColumns: {},
  isCheckedAll: false,
  pageCheckAll:null,
  checkedValues: [],
  filterCols:[]
};

const customTableSlice = createSlice({
  name: REDUX_SLICE_NAMES.CUSTOM_TABLE,
  initialState,
  reducers: {
    setCustomTableState: (state: CustomTableReducerType = initialState, action: ICustomTableAction) => {
      const listProperties = Object.keys(state);

      Object.keys(action.payload).forEach((field) => {
        if (listProperties.includes(field)) {
          state[field as keyof CustomTableReducerType] = action.payload[field as keyof CustomTableReducerType] as never;
        }
      });
    },
    inceasePageIndex: (state: CustomTableReducerType) => ({ ...state, pageIndex: state.pageIndex + 1 }),
    resetCustomTableState: () => initialState,
  },
});

const { setCustomTableState, resetCustomTableState, inceasePageIndex } = customTableSlice.actions;

export const useGetCustomTableState = () =>
  useAppSelector((state: RootState) => state[customTableSlice.name]) as CustomTableReducerType;

export const useSetCustomTableState = () => {
  const dispatch = useAppDispatch();
  return {
    setCustomTableField: (fields: Partial<CustomTableReducerType>) => {
      dispatch(setCustomTableState(fields));
    },
    inceasePageIndex: () => {
      dispatch(inceasePageIndex());
    },
    resetCustomTableState: () => {
      dispatch(resetCustomTableState());
    },
    onPageChange: (event: unknown, newPage: number) => {
      dispatch(setCustomTableState({ pageIndex: newPage }));
    },
    onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(setCustomTableState({ pageSize: parseInt(event.target.value, 10), pageIndex: 0 }));
    },
  };
};
export default customTableSlice;
